import React from 'react'
import { Link } from 'react-router-dom'
import { Fade } from "react-awesome-reveal";
import { AboutContent } from '../../api/homepage';
import icon from '../../images/icon/magic.png'

const About = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section id="about" className="about m-lr">
            <div className="about-wrapper sec-bg pos-rel pb-130 pt-130">
                <div className="container">
                    <div className="sec-title--two text-center">
                        <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                            <div className="sub-title wow fadeInDown" data-wow-duration="600ms">
                                <img src={icon} alt="" /> {AboutContent.subtitle}
                            </div>
                        </Fade>
                        <Fade direction='down' triggerOnce={'false'} duration={1500} delay={9}>
                            <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">
                                {AboutContent.title}
                            </h2>
                        </Fade>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 mt-50">
                            <div className="about-left">
                                <h2 className="title">Core Principles</h2>
                                {AboutContent.principles.map((principle, index) => (
                                    <div className="about-item_box ul_li" key={index}>
                                        <div className="xb-item--icon"><img src={principle.icon} alt="" /></div>
                                        <div className="xb-item--holder">
                                            <p className="xb-item--content"><span>{principle.label}</span> {principle.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-lg-6 mt-50">
                            <div className="about-right">
                                <div className="xb-item--holder">
                                    <h3 className="xb-item--title">{AboutContent.mission.title}</h3>
                                    <p className="xb-item--content">{AboutContent.mission.description}</p>
                                </div>
                                <div className="xb-item--holder">
                                    <h3 className="xb-item--title">{AboutContent.vision.title}</h3>
                                    <p className="xb-item--content">{AboutContent.vision.description}</p>
                                </div>
                            </div>
                        </div>
                        <div className="xb-btn text-center mt-90 wow fadeInUp" data-wow-duration="600ms">
                            <Fade direction='up' triggerOnce={'false'} duration={1500} delay={9}>
                                <Link onClick={ClickHandler} to={AboutContent.cta.link} className="thm-btn thm-btn--aso">{AboutContent.cta.text}</Link>
                            </Fade>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;